// client/src/ui/theme/EducaThemeProvider.js
//
// M06 Fase 4 - Provider que envuelve el arbol del dashboard con el tema
// Educa360. Uso recomendado: envolver Page_Dashboard y sus sub-paginas.

import React from "react";
import { ConfigProvider } from "antd";
import { educaTheme } from "./EducaTheme";

export function EducaThemeProvider({ children }) {
  return <ConfigProvider theme={educaTheme}>{children}</ConfigProvider>;
}
